// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"we_a bho_b bho_we"};